import { createPopup } from '@typeform/embed'
import '@typeform/embed/build/css/popup.css'

export default (formId) => ({
  init() {
    const { toggle } = createPopup(formId)
    this.open = toggle
  },
})
